import { AsperaError } from '../AsperaError';
export class Language {
    constructor(languageToUse, availableLanguages) {
        const foundLanguage = availableLanguages.get(languageToUse);
        if (!foundLanguage) {
            new AsperaError('Language: Invalid language requested will use English US', { languageToUse }, true);
        }
        const { code, name, location, data, timeFormat, dateFormat, timeFormat24, npsKey, hidden, rightToLeft } = foundLanguage ? foundLanguage : availableLanguages.get('en-us');
        this.code = code;
        this.name = name;
        this.location = location;
        this.data = data;
        this.timeFormat = timeFormat;
        this.dateFormat = dateFormat;
        this.timeFormat24 = timeFormat24;
        this.npsKey = npsKey;
        this.hidden = hidden;
        this.rightToLeft = !!rightToLeft;
    }
}
